var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4012 0.635602V3.58203H8.64901C8.00913 3.58203 7.57758 3.71596 7.35437 3.98382C7.13116 4.25167 7.01955 4.65346 7.01955 5.18917V7.29855H10.2896L9.85437 10.6021H7.01955V19.0731H3.60437V10.6021H0.758388V7.29855H3.60437V4.86551C3.60437 3.48158 3.99128 2.41016 4.76508 1.65123C5.53889 0.884857 6.5694 0.501673 7.8566 0.501673C8.95035 0.501673 9.79857 0.546316 10.4012 0.635602Z",
    fill: "#54729F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e10ffa25614feb444ac77db73e33a50f.svg";
export { ForwardRef as ReactComponent };